export const AUTH_TOKEN_SEARCH_PARAM = 'auth_token';
export const GOOGLE_PARAM = 'allow_google';
export const EXIT_BUTTON_PARAM = 'no_exit_controls';
export const PROJECT_PARAM = 'project';
